// app/studente/studenteDetail.js

(function () {
    'use strict';
    var controllerId = 'dashboard_Gestore';
    angular.module('app').controller(controllerId, ['$rootScope','common', '_', '$scope', '$filter', '$routeParams', 'datacontext', 'sectionMenu', dashboard_Gestore]);

    function dashboard_Gestore($rootScope, common, _, $scope, $filter, $routeParams, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = " dashview";

        var vm = this;       
        vm.title = 'Gestore Didattico';
        vm.sectionMenu = sectionMenu.setSection('');

        //filter per Anno: default l'anno corrente
        var dt = new Date();
        vm.filter = {};
        vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
        vm.filter.anno = vm.fAnno;

        vm.getAll = getAllFunc;

        vm.dashboard = {};
        vm.dashboard.numClassi = 0;
        vm.dashboard.numRisorse = 0;
        vm.dashboard.numStudenti = 0;        

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getDashboard(), getPerformance()];
            common.activateController(promises, controllerId)
                .then(function () {
                    if (!vm.fAnno)
                        vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
                    
                    getAllFunc();
                });
        }

        function getAllFunc() {
            vm.filter.anno = vm.fAnno == null ? -1 : vm.fAnno;

            getDashboard();
            getPerformance();
        }

        function getDashboard() {
            datacontext.dashboard_get(vm.filter.anno).then(function (data) {
                vm.dashboard = data;
            });
        }

        function getPerformance() {
            $scope.graficoPerformance = {
                'type': 'AreaChart',
                'options': {
                    'legend': { 'position': 'none' },
                    'colors': ['#3C454D'],
                    'vAxis': {
                        'title': 'Punteggio in %',
                        'titleTextStyle': { color: '#333' },
                        'minValue': 0,
                        'maxValue': 100
                    },
                    'hAxis': {
                        'textPosition': 'none',
                        'gridlines': { 'count': 10 }
                    },
                    'pointSize': 8
                },
                'formatters': {
                    'number': [
                        {
                            'columnNum': 1,
                            'decimalSymbol': ',',
                            'fractionDigits': 1,
                            'groupingSymbol': '.'
                        }
                    ]
                }
            };

            datacontext.dashboard_getAllStudenteSession(vm.filter.anno).then(function (data) {
                if (data == null || data.length == 0) {
                    $scope.graficoPerformance.data = {
                        "cols": [
                            { id: "description", label: "Data", type: "string" },
                            { id: "score", label: "Punteggio", type: "number" }
                        ],
                        "rows": []
                    };

                    return;
                }

                vm.sessionCount = data.length;                
                var sortedPerformance = _.sortBy(data, 'Data');
                vm.primaData = _.first(sortedPerformance).Data;
                vm.ultimaData = _.last(sortedPerformance).Data;                

                $scope.graficoPerformance.data = {
                    "cols": [
                        { id: "description", label: "Data", type: "string" },
                        { id: "score", label: "Punteggio", type: "number" }
                    ],
                    "rows": []
                };

                sortedPerformance.forEach(function (obj) {
                    var item = {};
                    item.c = [];

                    var desc = $filter('date')(obj.Data);

                    item.c.push({ v: desc });
                    item.c.push({ v: obj.Percentuale});

                    $scope.graficoPerformance.data.rows.push(item);
                });
            });
        }      
    }
})();